import * as THREE from 'three';

export const getHorizontalRotationBetweenPoints = (point1, point2) => {
  const vOX = new THREE.Vector3(0, 0, 1); // OX axis

  const direction = new THREE.Vector3();
  direction.subVectors(point1, point2);
  direction.y = 0;
  direction.normalize();
  vOX.normalize();

  const dot = direction.dot(vOX);
  const cross = new THREE.Vector3().crossVectors(vOX, direction).y;

  let horizontalRotation = Math.acos(dot);

  if (cross < 0) {
    horizontalRotation = -horizontalRotation;
  }

  return THREE.MathUtils.radToDeg(horizontalRotation);
};

export const getVerticalRotationBetweenPoints = (point1, point2) => {
  const p1 = point1.clone();
  const p2 = point2.clone();
  p1.y = 0;
  p2.y = 0;

  const deltaXZ = p1.distanceTo(p2);
  const deltaY = point2.y - point1.y;
  const angleRadians = Math.atan2(deltaY, deltaXZ);
  return THREE.MathUtils.radToDeg(angleRadians);
};

export const getRotationBetweenPoints = (point1, point2) => {
  const point1Vec3 = point1.isVector3 ? point1 : new THREE.Vector3(point1.x, point1.y, point1.z);
  const point2Vec3 = point1.isVector3 ? point1 : new THREE.Vector3(point2.x, point2.y, point2.z);
  const pitchDegrees = getVerticalRotationBetweenPoints(point1Vec3, point2Vec3);
  const yawDegrees = getHorizontalRotationBetweenPoints(point1Vec3, point2Vec3);
  return { pitchDegrees, yawDegrees };
};
